// extracted by mini-css-extract-plugin
export default {"container":"style_container__vGVzH","title_row":"style_title_row__g5r3Q","subtitle":"style_subtitle__FXyCl"};